export default __webpack_public_path__ + "static/media/circle-xmark-regular.8ef6e0a1.svg";